import { render } from "./claimExView.vue?vue&type=template&id=18faeb82&scoped=true"
import script from "./claimExView.vue?vue&type=script&lang=js"
export * from "./claimExView.vue?vue&type=script&lang=js"

import "./claimExView.vue?vue&type=style&index=0&id=18faeb82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18faeb82"]])

export default __exports__